// Inject styles into Shopify Forms shadow DOM (open mode allows this)
(function () {
  function injectFormStyles(el) {
    var sr = el.shadowRoot;
    if (!sr || sr.querySelector('style[data-calmoura]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-calmoura', '');
    style.textContent = [
      'button[type="submit"] {',
      '  font-size: 18px !important;',
      '  font-weight: 700 !important;',
      '}'
    ].join('\n');
    sr.appendChild(style);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;
        if (node.tagName === 'SHOPIFY-FORMS-EMBED') injectFormStyles(node);
        if (node.querySelectorAll) {
          node.querySelectorAll('shopify-forms-embed').forEach(injectFormStyles);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.querySelectorAll('shopify-forms-embed').forEach(injectFormStyles);
})();

$(document).ready(function () {
  var metaTag = $('meta[name="robots"]');
  var content = metaTag.attr("content");

  if (content) {
    var newContent = content.replace("nofollow", "follow");
    metaTag.attr("content", newContent);
  }

  $(".lesson-images-lists").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 2,
    centerMode: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".lesson_tab_head").click(function (e) {
    e.preventDefault();
    if ($(this).closest(".toggle_richtext").hasClass("active")) {
      $(".toggle_richtext").removeClass("active");
      $(".toggle_richtext .lesson_tab_content").slideUp(300);
    } else {
      $(".toggle_richtext").removeClass("active");
      $(this).closest(".toggle_richtext").addClass("active");
      $(".toggle_richtext .lesson_tab_content").slideUp(300);
      $(".toggle_richtext.active .lesson_tab_content").slideToggle(300);
    }
  });

  // Language selection
  $(".language").on("click", function (e) {
    e.preventDefault();
    let clickedvalue = $(this).attr("value");
    $(".custom-language-select").val(clickedvalue).change();
    $("#localization_form--header button").click();
  });

  // Currency selection
  $(".custom-currency-select").on("change", function () {
    let selectedValue = $(this).val();
    $(".custom-currency-select").off("change").val(selectedValue).change();
    $("#localization_form--header .currency-btn").click();
  });

  function pasueVideo() {
    $(".video").each(function () {
      $(this)[0].pause();
    });
    $(".femi_sl_video video").each(function () {
      $(this).parents(".femi_sl_video").find(".play_icon, img").show();
      $(this)[0].pause();
    });
    $(".nut_sl_item video").each(function () {
      $(this).parents(".nut_sl_item").find(".nut_video_play, img").show();
      $(this)[0].pause();
    });
  }

  $(".nut_slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    centerMode: true,
    variableWidth: true,
    infinite: true,
    swipeToSlide: true,
    touchThreshold: 100,
    speed: 500,
  });

  $(".nut_slider").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      pasueVideo();
      var parent = $(this).find(".nut_sl_item.slick-current");
      var video = parent.find("video")[0];
      var video_length = parent.find("video").length;
      if (video_length == 1) {
        parent.find(".nut_video_play, img").hide();
        video.play();
      } else {
        parent.find(".nut_video_play, img").show();
      }
    }
  );

  $("body").on(
    "click",
    ".nut_sl_item .nut_video_play, .nut_sl_item img",
    function () {
      pasueVideo();
      var parent = $(this).parents(".nut_sl_item");
      var video = parent.find("video")[0];
      if (video.paused) {
        parent.find(".nut_video_play, img").hide();
        video.play();
      } else {
        parent.find(".nut_video_play, img").show();
        video.pause();
      }
    }
  );

  $("body").on("click", ".nut_sl_item video", function () {
    var parent = $(this).parents(".nut_sl_item");
    var video = $(this)[0];
    if (video.paused) {
      parent.find(".nut_video_play, img").hide();
      video.play();
    } else {
      parent.find(".nut_video_play, img").show();
      video.pause();
    }
  });

  $(".testimonial_main").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: true,
    centerMode: true,
    centerPadding: "0",
    touchThreshold: 100,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".femi_care_sl").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    asNavFor: ".femi_care_sl_thumb",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          mobileFirst: false,
        },
      },
    ],
  });

  $(".femi_care_sl_thumb").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: ".femi_care_sl",
    dots: false,
    fade: true,
    focusOnSelect: true,
  });

  $(".femi_care_sl").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      pasueVideo();
      var parent = $(this).find(".femi_slide.slick-current");
      var video = parent.find("video")[0];
      parent.find(".play_icon, img").hide();
      video.play();
    }
  );

  $("body").on(
    "click",
    ".femi_slide.slick-current .play_icon, .femi_slide.slick-current img",
    function () {
      pasueVideo();
      var parent = $(this).parents(".femi_sl_video");
      var video = parent.find("video")[0];
      if (video.paused) {
        parent.find(".play_icon, img").hide();
        video.play();
      } else {
        parent.find(".play_icon, img").show();
        video.pause();
      }
    }
  );

  $("body").on("click", ".femi_slide.slick-current video", function () {
    var parent = $(this).parents(".femi_sl_video");
    var video = $(this)[0];
    if (video.paused) {
      parent.find(".play_icon, img").hide();
      video.play();
    } else {
      parent.find(".play_icon, img").show();
      video.pause();
    }
  });
  function getMonthNumberFromName(monthName) {
    return new Date(`${monthName} 1, 2022`).getMonth() + 1;
  }
  // Angel Number Calculator

  function getAngelNumber(day, month, year) {
    const dayDate = day; //$("#" + day).val();
    const monthDate = getMonthNumberFromName(month); //$("#" + month).val();
    const yearDate = $(year).val();
    let birthDate = dayDate + monthDate + yearDate;
    function calculateAngelNumber(birthDate) {
      var sum = 0;
      for (let i = 0; i < birthDate.length; i++) {
        sum += parseInt(birthDate[i], 10);
      }
      while (sum > 9 && sum !== 11 && sum !== 22 && sum !== 33) {
        sum = sum
          .toString()
          .split("")
          .reduce((acc, digit) => acc + parseInt(digit, 10), 0);
      }
      return sum;
    }
    if (dayDate != "" && monthDate != "" && yearDate != "") {
      var angelNumber = calculateAngelNumber(birthDate);
      var language = $("html").attr("lang");
      if (language === "pt-BR") {
        language = "pt";
      } else if (language === "zh-CN") {
        language = "zh";
      }

      let angle_number_content =
        language !== "en"
          ? `/${language}/pages/angel-number-${angelNumber}`
          : `/pages/angel-number-${angelNumber}`;
      window.location.assign(angle_number_content);
    }
  }

  window.addEventListener("klaviyoForms", function (e) {
    if (
      e.detail.formId == "XgWtMa" ||
      e.detail.formId == "Yn6yfv" ||
      e.detail.formId == "TivEZi" ||
      e.detail.formId == "X2AWyx"
    ) {
      if (e.detail.type === "submit") {
        gtag("send", "event", "Klaviyo form", "form_submit", e.detail.formId);
        let language = document.documentElement.lang;

        if (language === "ru") {
          //Angle_Calculator_Day_01JP7S1R272P8C3B8XS57429PB",
          //"Angle_Calculator_Month_01JP7S1R2DV3JPJPW3ZHHEHP0R",
          //"Angle_Calculator_Year_01JP7S1R2KER4SNJ1072P175WY"
          getAngelNumber(
            e.detail.metaData["Angle Calculator Day"],
            e.detail.metaData["Angle Calculator Month"],
            "#Angle_Calculator_Year_01JPMG0ARC4D960QJS3BPJB097"
          );
        } else {
          //"Angle_Calculator_Day_01JPMEXMEX1S1QZG19581F8KQJ",
          //"Angle_Calculator_Month_01JPMEXMF2TK62YPY4HPBSWWNK",
          //"Angle_Calculator_Year_01JPMEXMF7QHQD1GFND95V0565"
          getAngelNumber(
            e.detail.metaData["Angle Calculator Day"],
            e.detail.metaData["Angle Calculator Month"],
            "#Angle_Calculator_Year_01JPW5NPNS6HE0VSW3FTTXRJCP"
          );
        }
      }
    }
  });

  function getAngelName(name) {
    var name = $("#" + name).val();
    function calculateAngelNumber(name) {
      var uppercaseName = name.toUpperCase().replace(/\s/g, "");
      var letterValues = {
        A: 1,
        B: 2,
        C: 3,
        D: 4,
        E: 5,
        F: 6,
        G: 7,
        H: 8,
        I: 9,
        J: 1,
        K: 2,
        L: 3,
        M: 4,
        N: 5,
        O: 6,
        P: 7,
        Q: 8,
        R: 9,
        S: 1,
        T: 2,
        U: 3,
        V: 4,
        W: 5,
        X: 6,
        Y: 7,
        Z: 8,
      };
      var sum = 0;
      for (var i = 0; i < uppercaseName.length; i++) {
        var char = uppercaseName.charAt(i);
        if (letterValues[char]) {
          sum += letterValues[char];
        }
      }
      while (sum > 9 && sum != 11 && sum != 22 && sum != 33) {
        sum = sum
          .toString()
          .split("")
          .reduce((acc, digit) => acc + parseInt(digit), 0);
      }
      return sum;
    }
    if (name != "") {
      var nameNumber = calculateAngelNumber(name);
      var language = $("html").attr("lang");
      if (language === "pt-BR") {
        language = "pt";
      } else if (language === "zh-CN") {
        language = "zh";
      }

      let angle_number_content =
        language !== "en"
          ? `/${language}/pages/angel-number-${nameNumber}`
          : `/pages/angel-number-${nameNumber}`;

      window.location.assign(angle_number_content);
    }
  }

  window.addEventListener("klaviyoForms", function (e) {
    if (
      e.detail.formId == "XgWtMa" ||
      e.detail.formId == "Yn6yfv" ||
      e.detail.formId == "TivEZi" ||
      e.detail.formId == "X2AWyx"
    ) {
      if (e.detail.type == "submit") {
        gtag("send", "event", "Klaviyo form", "form_submit", e.detail.formId);
        let language = $("html").attr("lang");
        if (language == "ru") {
          getAngelName("Angle_Calculator_Name_01JP7SZC0QKDMV494632XVF4AH");
        } else {
          getAngelName("Angle_Calculator_Name_01JP7SF16KDDKDGPTT8ZJ517ZE");
        }
      }
    }
  });

  // $("#name-calculate-btn").on("click", function (e) {
  //   var name = $("#nameInput").val();
  //   const userEmail = $("#userNameEmail").val();
  //   function calculateAngelNumber(name) {
  //     e.preventDefault();
  //     var uppercaseName = name.toUpperCase().replace(/\s/g, "");
  //     var letterValues = {
  //       A: 1,
  //       B: 2,
  //       C: 3,
  //       D: 4,
  //       E: 5,
  //       F: 6,
  //       G: 7,
  //       H: 8,
  //       I: 9,
  //       J: 1,
  //       K: 2,
  //       L: 3,
  //       M: 4,
  //       N: 5,
  //       O: 6,
  //       P: 7,
  //       Q: 8,
  //       R: 9,
  //       S: 1,
  //       T: 2,
  //       U: 3,
  //       V: 4,
  //       W: 5,
  //       X: 6,
  //       Y: 7,
  //       Z: 8,
  //     };
  //     var sum = 0;
  //     for (var i = 0; i < uppercaseName.length; i++) {
  //       var char = uppercaseName.charAt(i);
  //       if (letterValues[char]) {
  //         sum += letterValues[char];
  //       }
  //     }
  //     while (sum > 9 && sum != 11 && sum != 22 && sum != 33) {
  //       sum = sum
  //         .toString()
  //         .split("")
  //         .reduce((acc, digit) => acc + parseInt(digit), 0);
  //     }
  //     return sum;
  //   }
  //   if (name != "") {
  //     var nameNumber = calculateAngelNumber(name);
  //     var language = $("html").attr("lang");
  //     if (language != "en") {
  //       var angle_number_content = `/${language}/pages/angel-number-${nameNumber}`;
  //     } else {
  //       var angle_number_content = `/pages/angel-number-${nameNumber}`;
  //     }

  //     window.location.assign(angle_number_content);
  //   }
  // });

  // $(".angle-number-form").submit(function (e) {
  //   const dayDate = $("#day").val();
  //   const monthDate = $("#month").val();
  //   const yearDate = $("#year").val();
  //   const userEmail = $("#userEmail").val();
  //   let birthDate = dayDate + monthDate + yearDate;
  //   e.preventDefault();
  //   function calculateAngelNumber(birthDate) {
  //     var sum = 0;
  //     for (let i = 0; i < birthDate.length; i++) {
  //       sum += parseInt(birthDate[i], 10);
  //     }
  //     while (sum > 9 && sum !== 11 && sum !== 22 && sum !== 33) {
  //       sum = sum
  //         .toString()
  //         .split("")
  //         .reduce((acc, digit) => acc + parseInt(digit, 10), 0);
  //     }
  //     return sum;
  //   }
  //   if (dayDate != "" && monthDate != "" && yearDate != "") {
  //     var angelNumber = calculateAngelNumber(birthDate);
  //     var language = $("html").attr("lang");
  //     if (language != "en") {
  //       var angle_number_content = `/${language}/pages/angel-number-${angelNumber}`;
  //     } else {
  //       var angle_number_content = `/pages/angel-number-${angelNumber}`;
  //     }
  //     window.location.assign(angle_number_content);
  //   }
  // });

  var header = $("#section-template--17228254806177__navigation_menu_j6WHKG");
  if (header.length) {
    var sticky = header.offset().top - 70;

    $(window).on("scroll", function () {
      if ($(window).scrollTop() > sticky) {
        header.addClass("shop-sticky");
        $(
          "#shopify-section-template--17228254806177__navigation_menu_j6WHKG"
        ).css("height", "90px");
      } else {
        header.removeClass("shop-sticky");
        $(
          "#shopify-section-template--17228254806177__navigation_menu_j6WHKG"
        ).css("height", "");
      }
    });
  }

  $(".menu-toggle").on("click", function (e) {
    e.preventDefault(); // Prevent default anchor behavior
    $(".custom-navigation").toggleClass("custom-mb-navigation-menu");
    $(".custom-navigation").removeClass(".custom-mb-navigation-menu");
  });

  function checkSectionInView() {
    var scrollPos = $(window).scrollTop();

    if (scrollPos === 0) {
      $(".navigation-links a").parent().removeClass("active");
      return;
    }

    $(".shop-section").each(function () {
      var sectionTop = $(this).offset().top;
      var sectionHeight = $(this).outerHeight();

      // Check if the section is in the viewport
      if (
        scrollPos >= sectionTop - 50 &&
        scrollPos < sectionTop + sectionHeight
      ) {
        var sectionId = "#" + $(this).attr("id");
        $(".navigation-links a").each(function () {
          var targetId = $(this).data("target");
          if (targetId == sectionId) {
            $(this).parent().addClass("active");
          } else {
            $(this).parent().removeClass("active");
          }
        });
      }
    });
  }

  // Listen to the scroll event and check each section
  $(window).on("scroll", function () {
    checkSectionInView();
  });

  // Initial check in case of a page load with scroll position already adjusted
  checkSectionInView();
  // Tarot Card Prediction
  const cardData = {
    1: {
      url: "https://calmoura.com/pages/king-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/King_of_Wands_430x_854aabc7-4b03-4414-a4e5-a4ed2a1890ca_360x617.webp",
      title: "King Of Wands",
    },
    2: {
      url: "https://calmoura.com/pages/queen-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/Queen_of_Wands_mini1_360x617.webp",
      title: "Queen Of Wands",
    },
    3: {
      url: "https://calmoura.com/pages/knight-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/Knight_Of_Wands_mini1_360x617.webp",
      title: "Knight Of Wands",
    },
    4: {
      url: "https://calmoura.com/pages/page-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/Page_Of_Wands_mini1_360x617.webp",
      title: "Page Of Wands",
    },
    5: {
      url: "https://calmoura.com/pages/ten-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/10_of_Wands_mini1_360x617.webp",
      title: "Ten Of Wands",
    },
    6: {
      url: "https://calmoura.com/pages/nine-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/9_of_Wands_mini1_360x617.webp",
      title: "Nine Of Wands",
    },
    7: {
      url: "https://calmoura.com/pages/eight-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/8_of_Wands_mini1_360x617.webp",
      title: "Eight Of Wands",
    },
    8: {
      url: "https://calmoura.com/pages/seven-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/7_of_Wands_mini1_360x617.webp",
      title: "Seven Of Wands",
    },
    9: {
      url: "https://calmoura.com/pages/six-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/6_of_Wands_desktop_mini1_360x617.webp",
      title: "Six Of Wands Desktop",
    },
    10: {
      url: "https://calmoura.com/pages/five-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/5_of_wands_mini1_360x617.webp",
      title: "Five Of Wands",
    },
    11: {
      url: "https://calmoura.com/pages/four-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/4_of_Wands_mini1_360x617.webp",
      title: "Four Of Wands",
    },
    12: {
      url: "https://calmoura.com/pages/three-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/3_of_Wands_mini1_360x617.webp",
      title: "Three Of Wands",
    },
    13: {
      url: "https://calmoura.com/pages/two-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/2_of_Wands_mini1_360x617.webp",
      title: "Two Of Wands",
    },
    14: {
      url: "https://calmoura.com/pages/ace-of-wands",
      image_url:
        "https://calmoura.com/cdn/shop/files/Ace_of_Wands_mini1_360x617.webp",
      title: "Ace Of Wands",
    },
    15: {
      url: "https://calmoura.com/pages/king-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/King_of_Sword_mini1_360x617.webp",
      title: "King Of Sword",
    },
    16: {
      url: "https://calmoura.com/pages/queen-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/Queen_of_Sword_mini1_360x617.webp",
      title: "Queen Of Swords",
    },
    17: {
      url: "https://calmoura.com/pages/knight-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/Knight_of_Sword_mini1_360x617.webp",
      title: "Knight Of Swords",
    },
    18: {
      url: "https://calmoura.com/pages/page-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/Page_of_Sword_mini1_360x617.webp",
      title: "Page Of Swords",
    },
    19: {
      url: "https://calmoura.com/pages/ten-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/10_of_Sword_mini1_360x617.webp",
      title: "Ten Of Swords",
    },
    20: {
      url: "https://calmoura.com/pages/nine-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/9_of_Sword_mini1_360x617.webp",
      title: "Nine Of Swords",
    },
    21: {
      url: "https://calmoura.com/pages/eight-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/8_of_Swords_mini1_360x617.webp",
      title: "Eight Of Swords",
    },
    22: {
      url: "https://calmoura.com/pages/seven-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/7_of_Swords_mini1_360x617.webp",
      title: "Seven Of Swords",
    },
    23: {
      url: "https://calmoura.com/pages/six-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/6_of_swords_mini1_360x617.webp",
      title: "Six Of Swords",
    },
    24: {
      url: "https://calmoura.com/pages/five-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/5_of_swords_mini1_360x617.webp",
      title: "Five Of Swords",
    },
    25: {
      url: "https://calmoura.com/pages/four-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/4_of_swords_mini1_360x617.webp",
      title: "Four Of Swords",
    },
    26: {
      url: "https://calmoura.com/pages/three-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/3_of_Swords_mini1_360x617.webp",
      title: "Three Of Swords",
    },
    27: {
      url: "https://calmoura.com/pages/two-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/2_of_Swords_mini1_360x617.webp",
      title: "Two Of Swords",
    },
    28: {
      url: "https://calmoura.com/pages/ace-of-swords",
      image_url:
        "https://calmoura.com/cdn/shop/files/Ace_of_Sword_mini1_360x617.webp",
      title: "Ace Of Sword",
    },
    29: {
      url: "https://calmoura.com/pages/king-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/King_Of_Cups_mini1_360x617.webp",
      title: "King Of Cups",
    },
    30: {
      url: "https://calmoura.com/pages/queen-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/Queen_Of_Cups_mini1_360x617.webp",
      title: "Queen Of Cups",
    },
    31: {
      url: "https://calmoura.com/pages/knight-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/Knight_of_Cups_mini1_360x617.webp",
      title: "Knight Of Cups",
    },
    32: {
      url: "https://calmoura.com/pages/page-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/Page_Of_Cups_mini1_360x617.webp",
      title: "Page Of Cups",
    },
    33: {
      url: "https://calmoura.com/pages/ten-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/10_of_cups_mini1_360x617.webp",
      title: "Ten Of Cups",
    },
    34: {
      url: "https://calmoura.com/pages/nine-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/9_of_Cups_mini1_360x617.webp",
      title: "Nine Of Cups",
    },
    35: {
      url: "https://calmoura.com/pages/eight-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/8_of_cups_mini1_360x617.webp",
      title: "Eight Of Cups",
    },
    36: {
      url: "https://calmoura.com/pages/seven-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/7_of_Cups_mini1_360x617.webp",
      title: "Seven Of Cups",
    },
    37: {
      url: "https://calmoura.com/pages/six-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/6_of_Cups_desktop_360x617.webp",
      title: "Six of Cups",
    },
    38: {
      url: "https://calmoura.com/pages/five-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/5_of_Cups_mini_360x617.webp",
      title: "Five Of Cups",
    },
    39: {
      url: "https://calmoura.com/pages/four-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/4_of_cups_mini_360x617.webp",
      title: "Four Of Cups",
    },
    40: {
      url: "https://calmoura.com/pages/three-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/3_of_Cups_mini_360x617.webp",
      title: "Three Of Cups",
    },
    41: {
      url: "https://calmoura.com/pages/two-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/2_of_Cups_mini_360x617.webp",
      title: "Two Of Cups",
    },
    42: {
      url: "https://calmoura.com/pages/ace-of-cups",
      image_url:
        "https://calmoura.com/cdn/shop/files/Ace_of_Cups_mini_360x617.webp",
      title: "Ace Of Cups",
    },
    43: {
      url: "https://calmoura.com/pages/king-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/King_of_Pentacles_mini1_360x617.webp",
      title: "King Of Pentacles",
    },
    44: {
      url: "https://calmoura.com/pages/queen-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/Queen_of_Pentacles_mini1_360x617.webp",
      title: "Queen Of Pentacles",
    },
    45: {
      url: "https://calmoura.com/pages/knight-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/Knight_of_Pentacles_mini1_360x617.webp",
      title: "Knight Of Pentacles",
    },
    46: {
      url: "https://calmoura.com/pages/page-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/Page_of_Pentacles_mini1_360x617.webp",
      title: "Page Of Pentacles",
    },
    47: {
      url: "https://calmoura.com/pages/ten-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/10_of_Pentacles_mini1_360x617.webp",
      title: "Ten Of Pentacles",
    },
    48: {
      url: "https://calmoura.com/pages/nine-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/9_of_Pentacles_mini1_360x617.webp",
      title: "Nine Of Pentacles",
    },
    49: {
      url: "https://calmoura.com/pages/eight-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/8_of_Pentacles_mini1_360x617.webp",
      title: "Eight Of Pentacles",
    },
    50: {
      url: "https://calmoura.com/pages/seven-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/7_of_Pentacles_mini1_360x617.webp",
      title: "Seven Of Pentacles",
    },
    51: {
      url: "https://calmoura.com/pages/six-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/6_of_Pentacles_mini1_360x617.webp",
      title: "Six Of Pentacles",
    },
    52: {
      url: "https://calmoura.com/pages/five-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/5_of_Pentacles_mini1_360x617.webp",
      title: "Five Of Pentacles",
    },
    53: {
      url: "https://calmoura.com/pages/four-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/4_of_Pentacles_mini1_360x617.webp",
      title: "Four Of Pentacles",
    },
    54: {
      url: "https://calmoura.com/pages/three-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/3_of_Pentacles_mini1_360x617.webp",
      title: "Three Of Pentacles",
    },
    55: {
      url: "https://calmoura.com/pages/two-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/2_of_Pentacles_mini1_360x617.webp",
      title: "Two Of Pentacles",
    },
    56: {
      url: "https://calmoura.com/pages/ace-of-pentacles",
      image_url:
        "https://calmoura.com/cdn/shop/files/Ace_of_Pentacles_mini1_360x617.webp",
      title: "Ace Of Pentacles",
    },
    57: {
      url: "https://calmoura.com/pages/the-fool",
      image_url:
        "https://calmoura.com/cdn/shop/files/0_card-the-fool_360x617.jpg",
      title: "The Fool",
    },
    58: {
      url: "https://calmoura.com/pages/the-magician",
      image_url:
        "https://calmoura.com/cdn/shop/files/1_card-the-magician_mini_360x617.webp",
      title: "The Magician",
    },
    59: {
      url: "https://calmoura.com/pages/the-high-priestess",
      image_url:
        "https://calmoura.com/cdn/shop/files/card-the-high-priestess_mini_360x617.webp",
      title: "The High Priestess",
    },
    60: {
      url: "https://calmoura.com/pages/the-empress",
      image_url:
        "https://calmoura.com/cdn/shop/files/card-the-empress_mini_360x617.webp",
      title: "The Empress",
    },
    61: {
      url: "https://calmoura.com/pages/the-emperor",
      image_url:
        "https://calmoura.com/cdn/shop/files/4_card-the-emperor_mini_360x617.webp",
      title: "The Emperor",
    },
    62: {
      url: "https://calmoura.com/pages/the-hierophant",
      image_url:
        "https://calmoura.com/cdn/shop/files/5_The_Hierophant_367x_367x_728ecb8f-3449-4cb9-bad4-e0ad5a0ae6a9_360x616.webp",
      title: "The Hierophant",
    },
    63: {
      url: "https://calmoura.com/pages/the-lovers",
      image_url:
        "https://calmoura.com/cdn/shop/files/6_card-the-lovers_mini_360x617.webp",
      title: "The Lovers",
    },
    64: {
      url: "https://calmoura.com/pages/the-chariot",
      image_url:
        "https://calmoura.com/cdn/shop/files/7_card-the-chariot_mini_360x617.webp",
      title: "The Chariot",
    },
    65: {
      url: "https://calmoura.com/pages/strength",
      image_url:
        "https://calmoura.com/cdn/shop/files/8_card-strength_mini_360x617.webp",
      title: "Strength",
    },
    66: {
      url: "https://calmoura.com/pages/the-hermit",
      image_url:
        "https://calmoura.com/cdn/shop/files/9_card-the-hermit_mini_360x617.webp",
      title: "The Hermit",
    },
    67: {
      url: "https://calmoura.com/pages/wheel-of-fortune",
      image_url:
        "https://calmoura.com/cdn/shop/files/10_card-wheel-of-fortune_mini_360x617.webp",
      title: "Wheel Of Fortune",
    },
    68: {
      url: "https://calmoura.com/pages/justice",
      image_url:
        "https://calmoura.com/cdn/shop/files/11_card-justice_mini_360x617.webp",
      title: "Justice",
    },
    69: {
      url: "https://calmoura.com/pages/the-hanged-man",
      image_url:
        "https://calmoura.com/cdn/shop/files/12_card-the-hanged-man_mini_360x617.webp",
      title: "The Hanged Man",
    },
    70: {
      url: "https://calmoura.com/pages/death",
      image_url:
        "https://calmoura.com/cdn/shop/files/13_card-death_mini_360x617.webp",
      title: "Death",
    },
    71: {
      url: "https://calmoura.com/pages/temperance",
      image_url:
        "https://calmoura.com/cdn/shop/files/14_card-temperance_mini_360x617.webp",
      title: "Temperance",
    },
    72: {
      url: "https://calmoura.com/pages/the-devil",
      image_url:
        "https://calmoura.com/cdn/shop/files/15_card-the-devil_mini_360x617.webp",
      title: "The Devil",
    },
    73: {
      url: "https://calmoura.com/pages/the-tower",
      image_url:
        "https://calmoura.com/cdn/shop/files/16_card-the-tower_mini_360x617.webp",
      title: "The Tower",
    },
    74: {
      url: "https://calmoura.com/pages/the-star",
      image_url:
        "https://calmoura.com/cdn/shop/files/17_card-the-star_mini_f5e4d5c0-db92-4ab3-b06c-8321dec8c39f_360x617.webp",
      title: "The Star",
    },
    75: {
      url: "https://calmoura.com/pages/the-moon",
      image_url:
        "https://calmoura.com/cdn/shop/files/18_card-the-moon_mini_360x617.webp",
      title: "The Moon",
    },
    76: {
      url: "https://calmoura.com/pages/the-sun",
      image_url:
        "https://calmoura.com/cdn/shop/files/19_card-the-sun_mini_360x617.webp",
      title: "The Sun",
    },
    77: {
      url: "https://calmoura.com/pages/judgement",
      image_url:
        "https://calmoura.com/cdn/shop/files/20_card-judgement_mini_360x617.webp",
      title: "Judgement",
    },
    78: {
      url: "https://calmoura.com/pages/the-world",
      image_url:
        "https://calmoura.com/cdn/shop/files/21_card-the-world_mini_360x617.webp",
      title: "The World",
    },
  };

  $(".welcome__lobby-list").removeClass("-setup");
  setTimeout(() => $(".tp-button-shuffle-cards").addClass("tp-scale"), 500);
  const selectedCards = [];
  const selectedImages = [];
  $(".tp-tarot-card-media-wrapper .image-link-wrapper").on(
    "click",
    function (e) {
      const href = $(this).attr("href");
      if (href === "#") {
        e.preventDefault();
      }
    }
  );

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  function getUniqueRandomNumbers(min, max, count = 5) {
    let numbers = new Set();
    while (numbers.size < count) {
      let randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
      numbers.add(randomNum);
    }
    return Array.from(numbers);
  }

  let allNumbers = [
    ...getUniqueRandomNumbers(1, 14),
    ...getUniqueRandomNumbers(15, 28),
    ...getUniqueRandomNumbers(29, 42),
    ...getUniqueRandomNumbers(43, 56),
    ...getUniqueRandomNumbers(57, 78),
  ];

  shuffleArray(allNumbers);
  assignId();

  function assignId() {
    $(".card-axis").each(function (index) {
      if (allNumbers[index]) {
        $(this).attr("data-random-number", allNumbers[index]);
      }
    });
  }

  $(".card-axis").on("click", function () {
    const randomNumber = $(this).attr("data-random-number");
    const selectedCount = $(".card-axis.-selected").length;
    const isAlreadySelected = $(this).hasClass("-selected");

    if (isAlreadySelected) {
      $(this).removeClass("-selected");
      $(this).find(".card-wrapper").removeClass("-selected");
      $(this).find(".card").removeClass("-selected");

      const index = selectedCards.indexOf(randomNumber);
      if (index > -1) {
        selectedCards.splice(index, 1);
      }
    } else {
      if (selectedCount >= 3) return;

      $(this).addClass("-selected");
      $(this).find(".card-wrapper").addClass("-selected");
      $(this).find(".card").addClass("-selected");

      selectedCards.push(randomNumber);
      // console.log(selectedCards)
    }

    $(".tp-button-reveal-card").toggleClass(
      "disabled",
      selectedCards.length < 3
    );

    if (selectedCards.length >= 3) {
      $(".tp-caption-description")
        .find(".tp-caption-before-heading p")
        .text("YOUR TAROT READING");
      $(".tp-caption-description").find(".tp-caption-number").addClass("hide");
      $(".tp-caption-description > p").text("IS COMPLETE!");
      $(".tp-caption-description").css("font-size", "34px");
    } else {
      $(".tp-caption-description")
        .find(".tp-caption-before-heading p")
        .text("PLEASE CHOOSE");
      $(".tp-caption-description")
        .find(".tp-caption-number")
        .removeClass("hide");
      $(".tp-caption-description")
        .find(".tp-caption-description > p")
        .text("TAROT CARDS");
      $(".tp-caption-description").css("font-size", "38px");
      const updatedCount = $(".card-axis.-selected").length;
      const remaining = 3 - updatedCount;
      $(".tp-caption-number").text(remaining);
    }
  });

  let emailTarotReadingPage = "";
  let emailynReadingPage = "";

  $(".tp-button-reveal-card").toggleClass("disabled", selectedCards.length < 3);

  $(".tp-button-reveal-card").on("click", async function (e) {
    e.preventDefault();

    // Select the email input in the Klaviyo form
    const klaviyoEmailInput = $('.klaviyo-form-Sns55r form input[type="email"]');

    // Get its value
    const emailValue = emailTarotReadingPage;

    // Check if empty
    if (!emailValue || emailValue.trim() === "") {
      // Add the error classes
      klaviyoEmailInput.addClass('go1557568162');
      klaviyoEmailInput.removeClass('go1618478605');

      // Set focus to the input
      klaviyoEmailInput.focus();

      // Set aria-invalid for accessibility
      klaviyoEmailInput.attr('aria-invalid', 'true');

      // Optional: add inline border color for instant feedback
      klaviyoEmailInput.css("border-color", "#D0331F");
      
      // Set aria attributes for accessibility
      klaviyoEmailInput.attr({
        'aria-invalid': 'true',
        'aria-describedby': 'klaviyo_ariaid_2'
      });
      return; // Stop execution if invalid
    }

    // Remove error styles if user starts typing
    klaviyoEmailInput.on('input', function() {
      if ($(this).val().trim() !== "") {
        $(this).removeClass('go1557568162');
        $(this).addClass('go1618478605');
        $(this).css("border-color", "");
        $(this).next('.error-msg').remove();
        // Remove aria attributes
        $(this).removeAttr('aria-invalid aria-describedby');

        // Remove error message if present
        $(this).next('.error-msg').remove();
      }
    });

    const api = "tarot_predictions";
    const language = "En";
    const auth =
      "Basic NjM5MDU1OjY2MWQ5YjZjZTVkODYxOTZiOGNkMmI0MDVkM2Y0ZDU5YWIyOTdjNTQ=";
    const data = {
      love: selectedCards[0],
      career: selectedCards[1],
      finance: selectedCards[2],
    };
    const button = $(this);
    const loader = button.find(".tp_loader");

    selectedImages.length = 0;
    if (selectedCards.length === 3) {
      loader.removeClass("hide");
      selectedCards.forEach((cardId) => {
        if (cardData[cardId]) {
          selectedImages.push(cardData[cardId]);
          // console.log(selectedImages);
        }
      });

      await $.ajax({
        url: "https://json.astrologyapi.com/v1/tarot_predictions",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        headers: {
          authorization: auth,
          "Content-Type": "application/json",
          "Accept-Language": language,
        },
        success: function (response) {
          const predictions = [
            response.love,
            response.career,
            response.finance,
          ];
          $(".tp-tarot-card").each(function (index) {
            const fullText = predictions[index];
            const words = fullText.split(" ");
            const previewText = words.slice(0, 50).join(" ");
            const hasMore = words.length > 50;
            const descContainer = $(this)
              .find(".tp-tarot-card-description")
              .empty();

            const text = $("<span>", {
              class: "tp-preview-text",
              text: previewText,
            });
            descContainer.append(text);

            if (hasMore) {
              const $readMoreBtn = $("<button>", {
                class: "tp-readmore-btn",
                text: "Read More",
              });
              descContainer.append($readMoreBtn);

              $readMoreBtn.on("click", function () {
                const isExpanded = text.hasClass("expanded");
                text
                  .toggleClass("expanded", !isExpanded)
                  .text(isExpanded ? previewText : fullText);
                $(this).text(isExpanded ? "Read More" : "Read Less");
              });
            }
          });
          $("html, body")
            .animate(
              {
                scrollTop:
                  $("#tp-tarot-card-details-wrapper").offset().top - 50,
              },
              700
            )
            .promise()
            .done(() => {
              selectedImages.forEach((imageUrl, imgindex) => {
                // console.log("img index", imgindex)
                $(".image-link-wrapper").removeClass("flip-active");
                $(".image-link-wrapper").each(function (index) {
                  // console.log("index", index + 1)
                  if (selectedImages[index]) {
                    $(this)
                      .find(".img-wrapper.back img")
                      .attr("src", selectedImages[index].image_url);
                    setTimeout(() => {
                      $(this).find(".img-wrapper.back").removeClass("hide");
                      $(this).attr("href", selectedImages[index].url);
                      $(this).addClass("flip-active");
                      $(".image-link-wrapper")
                        .find(".tp-tarot-image-card-title")
                        .text();
                      $(this)
                        .find(".tp-tarot-image-card-title")
                        .text(selectedImages[index].title);
                      $(this)
                        .find(".tp-tarot-image-card-title")
                        .addClass("active")
                        .removeClass("hide");
                    }, (index + 1) * 1000);
                  }
                });
              });
            });
          loader.addClass("hide");
        },
        error: function (error) {
          console.error("API error:", error);
          loader.addClass("hide");
        },
      });
    }
  });

  $(".tp-button-shuffle-cards").on("click", function () {
    let olddata = allNumbers;
    // console.log("Old Numbers:", olddata);
    shuffleArray(allNumbers);
    assignId();
    $(".welcome__lobby-list").removeClass("-shuffling");
    $(".welcome__lobby-list").addClass("-blocked -shuffling-half");
    $(".tp-button-shuffle-cards").removeClass("tp-scale");

    setTimeout(() => $(".welcome__lobby-list").addClass("-shuffling"), 100);
    setTimeout(
      () => $(".welcome__lobby-list").removeClass("-shuffling-half"),
      1500
    );
    setTimeout(
      () =>
        $(".welcome__lobby-list")
          .removeClass("-blocked -shuffling")
          .addClass("-shuffling-end"),
      6000
    );
    setTimeout(() => {
      $(".welcome__lobby-list").removeClass("-shuffling-end");
      $(".tp-button-shuffle-cards").addClass("tp-scale");
    }, 6100);

    selectedCards.length = 0;
    selectedImages.length = 0;
    // console.log(selectedCards)

    $(".tp-button-reveal-card").toggleClass(
      "disabled",
      selectedCards.length < 3
    );

    $(".card-axis, .card-wrapper, .card").removeClass("-selected");

    if (selectedCards.length >= 3) {
      $(".tp-caption-description")
        .find(".tp-caption-before-heading p")
        .text("YOUR TAROT READING");
      $(".tp-caption-description").find(".tp-caption-number").addClass("hide");
      $(".tp-caption-description > p").text("IS COMPLETE!");
      $(".tp-caption-description").css("font-size", "34px");
    } else {
      $(".tp-caption-description")
        .find(".tp-caption-before-heading p")
        .text("PLEASE CHOOSE");
      $(".tp-caption-description")
        .find(".tp-caption-number")
        .removeClass("hide");
      $(".tp-caption-description")
        .find(".tp-caption-description > p")
        .text("TAROT CARDS");
      $(".tp-caption-description").css("font-size", "38px");
      const updatedCount = $(".card-axis.-selected").length;
      const remaining = 3 - updatedCount;
      $(".tp-caption-number").text(remaining);
    }

    // console.log("Shuffled Numbers:", allNumbers);
  });

  let xPrev = 0;
  let dragValue = 0;

  $(".welcome").on("touchstart", function (event) {
    let initialDragValue =
      parseFloat($(".welcome__lobby-list").css("--m-drag")) || 0;
    let xStart = event.originalEvent.touches[0].pageX;

    const touchMoveHandler = function (e) {
      const xCurrent = e.originalEvent.touches[0].pageX;
      const deltaX = xCurrent - xStart;

      const sensitivity = 0.3;
      let newDragValue = initialDragValue + deltaX * sensitivity;
      newDragValue = Math.round(newDragValue);
      newDragValue = Math.max(-100, Math.min(100, newDragValue));

      dragValue = newDragValue;

      $(".welcome__lobby-list")[0].style.setProperty("--m-drag", dragValue);
      xPrev = xCurrent;
    };

    const touchEndHandler = function () {
      $(document).off("touchmove", touchMoveHandler);
      $(document).off("touchend", touchEndHandler);
    };

    xPrev = event.originalEvent.touches[0].pageX;
    initialDragValue = dragValue;

    $(document).on("touchmove", touchMoveHandler);
    $(document).on("touchend", touchEndHandler);
  });
  
  // Tarot card meaning
  $(".tcm-tab").on("click", function () {
    let tabId = $(this).attr("data-tab");
    $(".tcm-tab").removeClass("active");
    $(this).addClass("active");

    $(".tcm-tab-content").removeClass("active");
    $('.tcm-tab-content[data-tab="' + tabId + '"]').addClass("active");
  });

  $('.tcm-hero-keyword-link').on('click', function(e) {
    e.preventDefault();
    const linkdata = $(this).attr('href');
    
    const target = $(linkdata);
    if (target.length) {
      $("html, body").animate(
        {
          scrollTop: target.offset().top - 100,
        },
        000
      );
    }
  });

  const swiperCustomer = new Swiper(".hp-customers-wrapper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 3000,
    },
    grabCursor: true,
    breakpoints: {
      480: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      990: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  });

  $(".hp-reviews-link a").on("click", function (e) {
    e.preventDefault();
    const targetId = $(this).attr("href");
    const target = $(targetId);
    $("html, body").animate(
      {
        scrollTop: target.offset().top - 50,
      },
      700
    );

    history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search
    );
  });
  
  window.addEventListener("klaviyoForms", function (e) {
    if (e.detail.formId == "TrBvHb") {
      if (e.detail.type === "submit") {
        gtag("send", "event", "Klaviyo form", "form_submit", e.detail.formId);
        let tyPage =
          "https://calmoura.com/pages/7-free-tarot-classes-thank-you";
        window.location.assign(tyPage);
      }
    }
    if(e.detail.formId == "Sns55r") {
      if (e.detail.type === "submit") {
          // Grab the email from metaData
        emailTarotReadingPage = e.detail.metaData.$email;
      }
    }
    if(e.detail.formId == "UsxHGD") {
      if (e.detail.type === "submit") {
          // Grab the email from metaData
        emailynReadingPage = e.detail.metaData.$email;
      }
    }
  });
  
  const tarot_cards = [
    {
      id: 8,
      title: "The Fool",
      answer: "Yes",
      description: "Leap of faith, new beginnings",
      image_url:
        "https://calmoura.com/cdn/shop/files/THE_FOOL_1_367x_e98d4e4a-1868-4aca-9a70-9d0400b739b6_367x.webp?v=1713598485",
      url: "https://calmoura.com/pages/the-fool",
    },
    {
      id: 1,
      title: "The Magician",
      answer: "Yes",
      description: "You have the tools you need",
      image_url:
        "https://calmoura.com/cdn/shop/files/1_card-the-magician_mini_360x617.webp?v=1714078763",
      url: "https://calmoura.com/pages/the-magician",
    },
    {
      id: 22,
      title: "The High Priestess",
      answer: "Maybe",
      description: "Trust your intuition",
      image_url:
        "https://calmoura.com/cdn/shop/files/card-the-high-priestess_mini_360x617.webp?v=1714078763",
      url: "https://calmoura.com/pages/the-high-priestess",
    },
    {
      id: 13,
      title: "The Empress",
      answer: "Yes",
      description: "Growth, abundance, nurturing",
      image_url:
        "https://calmoura.com/cdn/shop/files/card-the-empress_mini_360x617.webp?v=1714078763",
      url: "https://calmoura.com/pages/the-empress",
    },
    {
      id: 3,
      title: "The Emperor",
      answer: "Yes",
      description: "Stability, structure, power",
      image_url:
        "https://calmoura.com/cdn/shop/files/4_card-the-emperor_mini_360x617.webp?v=1714078764",
      url: "https://calmoura.com/pages/the-emperor",
    },
    {
      id: 2,
      title: "The Hierophant",
      answer: "Maybe",
      description: "Seek guidance or tradition",
      image_url:
        "https://calmoura.com/cdn/shop/files/5_The_Hierophant_367x_367x_728ecb8f-3449-4cb9-bad4-e0ad5a0ae6a9_360x616.webp?v=1714080614",
      url: "https://calmoura.com/pages/the-hierophant",
    },
    {
      id: 17,
      title: "The Lovers",
      answer: "Yes",
      description: "Union, harmony, choice",
      image_url:
        "https://calmoura.com/cdn/shop/files/6_card-the-lovers_mini_360x617.webp?v=1714084927",
      url: "https://calmoura.com/pages/the-lovers",
    },
    {
      id: 9,
      title: "The Chariot",
      answer: "Yes",
      description: "Determination leads to success",
      image_url:
        "https://calmoura.com/cdn/shop/files/7_card-the-chariot_mini_360x617.webp?v=1714085045",
      url: "https://calmoura.com/pages/the-chariot",
    },
    {
      id: 12,
      title: "Strength",
      answer: "Yes",
      description: "Courage, inner power",
      image_url:
        "https://calmoura.com/cdn/shop/files/8_card-strength_mini_360x617.webp?v=1714085177",
      url: "https://calmoura.com/pages/strength",
    },
    {
      id: 5,
      title: "The Hermit",
      answer: "No",
      description: "Time for solitude",
      image_url:
        "https://calmoura.com/cdn/shop/files/9_card-the-hermit_mini_360x617.webp?v=1714085286",
      url: "https://calmoura.com/pages/the-hermit",
    },
    {
      id: 14,
      title: "Wheel Of Fortune",
      answer: "Maybe",
      description: "Fate at play, uncertain",
      image_url:
        "https://calmoura.com/cdn/shop/files/10_card-wheel-of-fortune_mini_360x617.webp?v=1714085544",
      url: "https://calmoura.com/pages/wheel-of-fortune",
    },
    {
      id: 10,
      title: "Justice",
      answer: "Maybe",
      description: "Outcomes depend on balance",
      image_url:
        "https://calmoura.com/cdn/shop/files/11_card-justice_mini_360x617.webp?v=1714085899",
      url: "https://calmoura.com/pages/justice",
    },
    {
      id: 19,
      title: "The Hanged Man",
      answer: "No",
      description: "Delay, surrender, wait",
      image_url:
        "https://calmoura.com/cdn/shop/files/12_card-the-hanged-man_mini_360x617.webp?v=1714086009",
      url: "https://calmoura.com/pages/the-hanged-man",
    },
    {
      id: 4,
      title: "Death",
      answer: "Yes",
      description: "Transformation, end = new",
      image_url:
        "https://calmoura.com/cdn/shop/files/13_card-death_mini_360x617.webp?v=1714086161",
      url: "https://calmoura.com/pages/death",
    },
    {
      id: 7,
      title: "Temperance",
      answer: "Yes",
      description: "Patience brings results",
      image_url:
        "https://calmoura.com/cdn/shop/files/14_card-temperance_mini_360x617.webp?v=1714086287",
      url: "https://calmoura.com/pages/temperance",
    },
    {
      id: 6,
      title: "The Devil",
      answer: "No",
      description: "Unhealthy attachments",
      image_url:
        "https://calmoura.com/cdn/shop/files/15_card-the-devil_mini_360x617.webp?v=1714086895",
      url: "https://calmoura.com/pages/the-devil",
    },
    {
      id: 20,
      title: "The Tower",
      answer: "No",
      description: "Sudden upheaval",
      image_url:
        "https://calmoura.com/cdn/shop/files/16_card-the-tower_mini_360x617.webp?v=1714087966",
      url: "https://calmoura.com/pages/the-tower",
    },
    {
      id: 15,
      title: "The Star",
      answer: "Yes",
      description: "Hope and healing",
      image_url:
        "https://calmoura.com/cdn/shop/files/17_card-the-star_mini_f5e4d5c0-db92-4ab3-b06c-8321dec8c39f_360x617.webp?v=1714087967",
      url: "https://calmoura.com/pages/the-star",
    },
    {
      id: 16,
      title: "The Moon",
      answer: "Maybe",
      description: "Confusion, hidden truths",
      image_url:
        "https://calmoura.com/cdn/shop/files/18_card-the-moon_mini_360x617.webp?v=1714087966",
      url: "https://calmoura.com/pages/the-moon",
    },
    {
      id: 18,
      title: "The Sun",
      answer: "Yes",
      description: "Joy, clarity, success",
      image_url:
        "https://calmoura.com/cdn/shop/files/19_card-the-sun_mini_360x617.webp?v=1714087967",
      url: "https://calmoura.com/pages/the-sun",
    },
    {
      id: 11,
      title: "Judgement",
      answer: "Yes",
      description: "Renewal, inner calling",
      image_url:
        "https://calmoura.com/cdn/shop/files/20_card-judgement_mini_360x617.webp?v=1714087966",
      url: "https://calmoura.com/pages/judgement",
    },
    {
      id: 21,
      title: "The World",
      answer: "No",
      description: "Completion, fulfillment",
      image_url:
        "https://calmoura.com/cdn/shop/files/21_card-the-world_mini_360x617.webp?v=1714087967",
      url: "https://calmoura.com/pages/the-world",
    },
  ];
  tarot_cards.forEach(function (card) {
    $(".major-card-body").append(
      `<tr class="major-cards-data">
        <td class="major-card-head-content title"><a href="${card.url}" target="_blank">${card.title}</a></td>
        <td class="major-card-head-content answer">${card.answer}</td>
        <td class="major-card-head-content description">${card.description}</td>
      </tr>`
    );
  });
  const cards = $(".yn-tarot-reading-card");
  // $('.yn-button-shuffle-cards').addClass('yn-shuffle-scale')
  const numbers = Array.from({ length: 22 }, (_, i) => i + 1);
  const shuffle = (arr) => arr.sort(() => Math.random() - 0.5);
  const assignNumbers = (nums) => {
    cards.each((i, el) => $(el).attr("data-number", nums[i]));
  };
  let selectedCardNumber = null;
  $(".major-card-test").hide();
  $(".select-major-card").on("click", function () {
    $(this).toggleClass("rotate-arrow");
    $(".major-card-test").slideToggle("slow");
  });
  
  $(".yn-button-reveal-card-wrapper")
    .addClass("disabled")
    .attr("aria-disabled", true);
  
    $(cards).on("click", function () {
    const cardNumber = $(this).attr("data-number");

    if (selectedCardNumber === Number(cardNumber)) {
      $(this).removeClass("selected");
      selectedCardNumber = null;
      $(".yn-button-reveal-card-wrapper")
        .addClass("disabled")
        .attr("aria-disabled", true);
    } else {
      $(cards).removeClass("selected");
      $(this).addClass("selected");
      selectedCardNumber = Number(cardNumber);
      $(".yn-button-reveal-card-wrapper")
        .removeClass("disabled")
        .attr("aria-disabled", false);
    }
  });

  assignNumbers(shuffle([...numbers]));

  const oldTitle = $(".yn-button-shuffle-cards").text();
  $(".yn-button-shuffle-cards").on("click", function () {
    const newTitle = `Shuffling...`;
    $(this).html(newTitle);
    $(this).addClass("disabled");
    const selectedCardEl = $(
      ".tarotController__CardWrapper-sc-18x7n2k-0.selected"
    );
    selectedCardEl.addClass("returning").removeClass("drawn");

    const current = cards.map((_, el) => $(el).attr("data-number")).get();
    assignNumbers(shuffle([...current]));

    $(cards).removeClass("selected");
    selectedCardNumber = null;
    $(".yn-tarot-image-content-wrapper .yn-card-description").text("");
    $(".yn-tarot-image-content-wrapper .yn-card-value").text("");
    $(".yn-tarot-card-link").attr("href", "#").removeClass("flip-active");
    $(".yn-tarot-card-link .back-image img").attr("src", "");

    setTimeout(() => $(selectedCardEl).removeClass("returning"), 500);
    $(".yn-button-reveal-card-wrapper")
      .addClass("disabled")
      .attr("aria-disabled", true);

    $(cards).removeClass("idle").addClass("gathering");
    setTimeout(() => $(cards).removeClass("gathering idle").addClass("gathered"),800);
    setTimeout(() => $(cards[cards.length - 1]).addClass("lifting"), 800);
    setTimeout(() => $(cards[cards.length - 1]).removeClass("lifting").addClass("replacing"),1000);
    // setTimeout(() => $(cards[cards.length - 1]).removeClass("replacing"), 1200);
    setTimeout(() => $(cards[cards.length - 2]).addClass("lifting"), 1200);
    setTimeout(() => $(cards[cards.length - 2]).removeClass("lifting").addClass("replacing"),1400);
    // setTimeout(() => $(cards[cards.length - 2]).removeClass("replacing"), 1600);
    setTimeout(() => $(cards[cards.length - 3]).addClass("lifting"), 1600);
    setTimeout(() => $(cards[cards.length - 3]).removeClass("lifting").addClass("replacing"),1800);
    // setTimeout(() => $(cards[cards.length - 3]).removeClass("replacing"), 2000);
    setTimeout(() => $(cards).removeClass("replacing"), 2000);
    setTimeout(() => $(cards).removeClass("gathered").addClass("dealing"),2200);
    setTimeout(() => {
      $(cards).removeClass("dealing");
      $(this).removeClass("disabled").html(oldTitle);
    }, 3000);
    $(cards).addClass("idle");
  });

  $(".yn-tarot-card-link").on("click", function (e) {
    const href = $(this).attr("href");
    if (href === "#") {
      e.preventDefault();
    }
  });

  $(".yn-button-reveal-card-wrapper").on("click", async function (event) {
    event.preventDefault();

    
    if (selectedCardNumber) {
      // Select the email input in the Klaviyo form
      const klaviyoEmailInput = $('.klaviyo-form-UsxHGD form input[type="email"]');
  
      // Get its value
      const emailValue = emailynReadingPage;
  
      // Check if empty
      if (!emailValue || emailValue.trim() === "") {
        // Add the error classes
        klaviyoEmailInput.addClass('go1557568162');
        klaviyoEmailInput.removeClass('go1618478605');
  
        // Set focus to the input
        klaviyoEmailInput.focus();
  
        // Set aria-invalid for accessibility
        klaviyoEmailInput.attr('aria-invalid', 'true');
  
        // Optional: add inline border color for instant feedback
        klaviyoEmailInput.css("border-color", "#D0331F");
        
        // Set aria attributes for accessibility
        klaviyoEmailInput.attr({
          'aria-invalid': 'true',
          'aria-describedby': 'klaviyo_ariaid_2'
        });
        return; // Stop execution if invalid
      }
  
      // Remove error styles if user starts typing
      klaviyoEmailInput.on('input', function() {
        if ($(this).val().trim() !== "") {
          $(this).removeClass('go1557568162');
          $(this).addClass('go1618478605');
          $(this).css("border-color", "");
          $(this).next('.error-msg').remove();
          // Remove aria attributes
          $(this).removeAttr('aria-invalid aria-describedby');
  
          // Remove error message if present
          $(this).next('.error-msg').remove();
        }
      });

      const api = "yes_no_tarot";
      const language = "En";
      const auth =
        "Basic NjM5MDU1OjY2MWQ5YjZjZTVkODYxOTZiOGNkMmI0MDVkM2Y0ZDU5YWIyOTdjNTQ=";
      const data = { tarot_id: selectedCardNumber };
      const loader = $(this).find(".yn_loader");

      loader.removeClass("hide");

      await $.ajax({
        url: `https://json.astrologyapi.com/v1/yes_no_tarot`,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        headers: {
          authorization: auth,
          "Content-Type": "application/json",
          "Accept-Language": language,
        },
        success: function (response) {
          $("html, body")
            .animate(
              {
                scrollTop:
                  $("#yn-tarot-card-details-wrapper").offset().top -
                  ($(window).width() < 669 ? 70 : 100),
              },
              700
            )
            .promise()
            .done(() => {
              // selectedCardEl.removeClass("drawing").addClass("drawn");
              $(".yn-tarot-card-content-description .yn-card-description").text(
                response.description
              );
              $(".yn-tarot-image-content-wrapper .yn-card-value").text(
                response.value
              );
              const tarotCard = tarot_cards.map((card) => {
                if (selectedCardNumber === card.id) {
                  const card_image = card.image_url;
                  $(".yn-tarot-card-link .back-image img").attr(
                    "src",
                    card_image
                  );
                  $(".yn-tarot-card-link")
                    .attr("href", card.url)
                    .addClass("flip-active");
                }
              });
              loader.addClass("hide");
              
          $(".yn-button-reveal-card-wrapper")
            .addClass("disabled")
            .attr("aria-disabled", true);
          selectedCardNumber = null;
          $(cards).removeClass("selected");
            });
        },
        error: function (error) {
          console.error("API error:", error);
        },
      });
    }
  });  
  
  $('a').each(function() {
    let href = $(this).attr('href');

    try {
      let linkHost = new URL(href, window.location.origin).hostname;

      if (linkHost === "learn.calmoura.com") {
        let relAttr = $(this).attr('rel');

        if (relAttr) {
          let newRel = relAttr.split(/\s+/).filter(val => val.toLowerCase() !== 'noreferrer').join(' ');
          $(this).attr('rel', newRel);
        }

        // Get the current UTM parameters, if any, from the URL
        let url = new URL(href, window.location.origin);
        let searchParams = url.searchParams;

        // Define the UTM parameters
        const utmSource = "shopify"; // Change these values as needed
        const utmMedium = "referral";
        const utmCampaign = "mainstore";

        // Add the UTM parameters to the searchParams object
        if (!searchParams.has("utm_source")) {
          searchParams.append("utm_source", utmSource);
        }
        if (!searchParams.has("utm_medium")) {
          searchParams.append("utm_medium", utmMedium);
        }
        if (!searchParams.has("utm_campaign")) {
          searchParams.append("utm_campaign", utmCampaign);
        }

        // Set the updated href with the UTM parameters
        $(this).attr('href', url.toString());
      }
    } catch (e) {
      // Ignore invalid hrefs
    }
  });

  
  $('.article-content-wrapper .rte img, .zpa-image-container img').each(function () {
    let img = $(this);
    let src = img.attr('src');

    if (!src) return; // no src → skip

    // Extract filename from URL
    let filename = src.split('/').pop(); // "my-image-name.jpg"
    filename = filename.split('?')[0]; // remove Shopify params
    filename = filename.replace(/\.[^/.]+$/, ''); // remove extension

    // Convert dashes/underscores to spaces for nicer ALT
    let altText = filename.replace(/[-_]+/g, ' ').trim();

    // Only set alt if missing
    if (!img.attr('alt') || img.attr('alt').trim() === '') {
      img.attr('alt', altText);
    }
  });
});
